export default __webpack_public_path__ + "static/genre_02-7555a6a303b1521acff4989cedf9d5e7.png";